
import BaseWeatherWidget from '../../../../base/components/sidebar/widgets/WeatherWidget.vue'

export default class WeatherWidget extends BaseWeatherWidget {}
